import React, { Component } from 'react';

import { withRouter } from '../withRouter';
import { withTheme } from '../withTheme';

class PresenterFooter extends Component {
  state = {
    // index into the [img, fallbackImg] candidate list
    srcIndex: 0,
    exhausted: false,
  };

  get candidates() {
    return [this.props.img, this.props.fallbackImg].filter(Boolean);
  }

  handleImageError = () => {
    this.setState((prev) => {
      const next = prev.srcIndex + 1;
      if (next >= this.candidates.length) {
        return { exhausted: true };
      }
      return { srcIndex: next };
    });
  };

  render() {
    const { srcIndex, exhausted } = this.state;
    const src = this.candidates[srcIndex];

    // Full-width footer banner (image expected at 1920x148 px).
    // Tries the presenter footer, then the voter footer, then falls back
    // to a plain colored bar if none load.
    return (
      <div
        style={{
          backgroundColor: this.props.backgroundColor,
          width: '100%',
        }}
      >
        {src && !exhausted && (
          <img
            onError={this.handleImageError}
            alt=''
            src={src}
            style={{
              display: 'block',
              width: '100%',
              objectFit: 'contain',
            }}
          />
        )}
      </div>
    );
  }
}

export default withRouter(withTheme(PresenterFooter));
